import { useEffect } from "react";
import { loadMetaPixel, readConsent } from "../utils/consentAnalytics";
import { syncMetaClickIds } from "../utils/metaClickIds";

// Loads the Meta Pixel on a FUNNEL page once we know consent was already granted — including for a
// returning consented visitor, where the banner is hidden and so would not load it. Rendered by the
// funnel layouts only (not RootLayout): the Pixel must not fire on /app, /admin or store pages, where
// it would leak authenticated URLs to Meta and pollute the retargeting audience. Off in non-production
// builds and inert without a pixel id. Renders nothing.
export function ConsentedMetaPixel({ pixelId }: { pixelId: string | null }) {
  useEffect(() => {
    if (!import.meta.env.PROD) return;
    // Reconcile the ad-click cookies with the URL first: a returning consented visitor materializes
    // `_fbc` from the URL immediately (before any Stripe hop). No-op while undecided (nothing is stored
    // before consent) and without a pixel id, like the Pixel loader below.
    syncMetaClickIds(pixelId);
    if (readConsent() === "granted") loadMetaPixel(pixelId);
  }, [pixelId]);

  return null;
}
